// ArtworkGrid.jsx
import "react-photo-album/rows.css";
import React, { useState } from "react";
import PhotoModal from "./PhotoModal";
import { RowsPhotoAlbum } from "react-photo-album";

export default function ArtworkGrid({ artworks, rowsize }) {
    const [selectedIndex, setSelectedIndex] = useState(null);

    return (
        <div style={{margin: 20}}>
            { artworks.length === 1 ? (
                //Single photo layout
                <div style={{ height: rowsize || 400, display: "flex"}} onClick={() => setSelectedIndex(0)}>
                    <img loading="lazy"
                        src={artworks[0].src}
                        alt={artworks[0].name}
                        style={{ maxHeight: "100%", maxWidth: "100%", objectFit: "contain", cursor: "pointer" }}
                    />
                </div>
            ) : (
                // Grid layout
                <RowsPhotoAlbum
                    photos={artworks}
                    onClick={({ index }) => setSelectedIndex(index)}
                    spacing={15}
                    targetRowHeight={rowsize || 400}
                />
            )}
            <PhotoModal photos={artworks} selectedIndex={selectedIndex} onClose={() => setSelectedIndex(null)}/>
        </div>
    );
}
